import { createFileRoute } from "@tanstack/react-router";

import GameAndSessionActionPage from "~/pages/gameSession/GameAndSessionActionPage.tsx";

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/score-taking/session-actions")({
    component: GameAndSessionActionPage,
});
